import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"

const addInventorySetting = (inventory_series) => {
  return axios.post(API + "company/company-settings/", {
    inventory_series
  },{headers: authHeader(),});
};
const AddInventorySettingService = {
    addInventorySetting,
    
  };
  export default AddInventorySettingService;